import { Inject, Injectable, Optional } from '@angular/core';
import {
  CanLoad,
  Route,
  UrlSegment
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { HomepageNavigatorService } from '~shared/modules/homepage-navigator/homepage-navigator.service';
import { catchError, switchMap, take } from 'rxjs/operators';
import { StoryblokApiResponse } from '~app/modules/storyblok/models/storyblok-api-response.model';
import { CountryCode, NUMBER_1 } from '~shared/constants';
import { StoryblokService } from '~app/modules/storyblok/services';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { getCountryDomainCode } from '~server/utils/country-detection.util';

@Injectable({
  providedIn: 'root'
})
export class CustomPlpGuard implements CanLoad {

  constructor(
    private router: HomepageNavigatorService,
    private storyblokService: StoryblokService,
    @Optional() @Inject(REQUEST) private webAppBuyerRequest: any,
  ) {
  }

  canLoad(_route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    const storySlug: string = segments[NUMBER_1]?.path
    if (storySlug) {
      return this.loadStoryblokStory(storySlug);
    }

    return this.router.navigateToHomepage();
  }

  private loadStoryblokStory(slug: string): Observable<boolean> {
    const market: CountryCode = getCountryDomainCode(this.webAppBuyerRequest);
    const url: string = `${market}/landing/${slug}`;

    return this.storyblokService.getStoryByHttp(url).pipe(
      take(1),
      switchMap((response: StoryblokApiResponse) => {
        const { story } = response;
        const { ProductList } = story?.content;

        if (!ProductList?.selectedProducts?.length) {
          return this.router.navigateToNotFoundPage();
        }

        return of(true);
      }),

      catchError(() => this.router.navigateToHomepage())
    );
  }
}
